import {register} from '@shopify/theme-sections'
import '../../styles/sections/section-flexible-table-content.scss'

export default register(`section-flexible-table-content`, {
    onLoad() {

    },
    onUnload() {

    },
})
